module.exports = __webpack_public_path__ + "static/codinglab-05b793eeae2671d8cb5efbe2b0b2fa03.png";